import React from "react";
import {Outlet} from "react-router-dom";

import styles from "./PublicAuthRouteLayout.module.scss";

export default function PublicAuthRouteLayout() {
  return (
    <div className={styles.screen}>
      <Outlet />
    </div>
  );
}
